import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import Checkbox from '../../SurveyComponents/Checkbox';

const MultipleChoice = ({
  question,
  saveUpdatedAnswers,
  currentQuestionDet,
  handlePreviousQuestion,
  handleNextQuestion,
  displayedQuestionIndex,
  totalQuestions,
  isFading,
  type // 'single' or 'multi'
}) => {
  const [selectedOptions, setSelectedOptions] = React.useState(
    currentQuestionDet ? (type === 'multi' ? JSON.parse(currentQuestionDet) : currentQuestionDet) : (type === 'multi' ? [] : '')
  );

  const handleOptionChange = (option) => {
    if (type === 'multi') {
      const newSelected = selectedOptions.includes(option)
        ? selectedOptions.filter(item => item !== option)
        : [...selectedOptions, option];
      setSelectedOptions(newSelected);
      saveUpdatedAnswers(JSON.stringify(newSelected));
    } else {
      setSelectedOptions(option);
      saveUpdatedAnswers(option);
    }
  };

  return (
    <Card isFading={isFading}>
      <SmallText>Survey Question</SmallText>
      <Progress>{displayedQuestionIndex} of {totalQuestions} questions</Progress>
      <Question>{question.question}</Question>
      
      <OptionsContainer>
              {question.options.map((option, index) => {
                  return (
          <OptionRow key={index}>
            {type === 'multi' ? (
              <Checkbox
                id={`checkbox_${index}`}
                checked={selectedOptions.includes(option)}
                onChange={() => handleOptionChange(option)}
                label={option}
                color="#2a3039"
                checkColor="#0275FF"
              />
            ) : (
              <Radio
                type="radio"
                name="single-choice"
                checked={selectedOptions === option}
                onChange={() => handleOptionChange(option)}
              />
            )}
            {type === 'single' && <OptionLabel>{option}</OptionLabel>}
          </OptionRow>
        )})}
      </OptionsContainer>

      <ButtonContainer>
        {displayedQuestionIndex > 1 && (
          <BackButton onClick={handlePreviousQuestion}>Back</BackButton>
        ) || (
          <div style={{ width: "100px" }}></div>
        )}
        <NextButton 
          onClick={handleNextQuestion}
          disabled={type === 'multi' ? selectedOptions.length === 0 : !selectedOptions}
        >
          {displayedQuestionIndex < totalQuestions ? "Next" : "Submit"}
        </NextButton>
      </ButtonContainer>
    </Card>
  );
};

export default MultipleChoice;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
  overflow: hidden;
  padding: 30px;
  margin-top: 20px;
  flex-direction: column;
  position: relative;
  animation: ${({ isFading }) =>
    isFading ? css`${fadeOut} 0.5s ease-out forwards` : css`${fadeIn} 0.5s ease-out forwards`};
`;

const SmallText = styled.div`
  font-size: 12px;
  color: #2D70E2;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 10px;
`;

const Progress = styled.div`
  font-size: 12px;
  color: #2a3039;
  margin-bottom: 5px;
  position: absolute;
  top: 30px;
  right: 20px;
`;

const Question = styled.div`
  max-width: 100%;
  line-height: 1.7;
  font-size: 16px;
  font-weight: 400;
  color: #2a3039;
  margin-bottom: 15px;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  background-color: #f8f9fa;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e9ecef;
  }
`;

const Radio = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

const OptionLabel = styled.label`
  font-size: 14px;
  color: #2a3039;
  cursor: pointer;
  flex: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
`;

const BackButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: #2D70E2;
  background-color: #EBF1FD;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const NextButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
`;
